import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Phone } from "lucide-react";
import { Button } from "./ui/button";
import StarRating from "./StarRating";
import { companyInfo } from "../data/mock";

// Donkere paginakop voor subpagina's (dienst / zakelijk / prijzen). Header blijft leesbaar.
const PageHero = ({ crumbs = [], badge, title, intro, extra, aside, testId = "page-hero" }) => (
  <section
    id="home"
    className="relative bg-gradient-to-br from-slate-900 via-sky-900 to-teal-900 pt-32 pb-20 overflow-hidden"
    data-testid={testId}
  >
    <div className="absolute -top-24 -right-24 w-96 h-96 bg-sky-500/10 rounded-full blur-3xl" />
    <div className="absolute -bottom-24 left-1/3 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl" />
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <nav aria-label="Kruimelpad" className="flex flex-wrap items-center gap-2 text-sm text-white/60 mb-6">
        {crumbs.map((c, i) => (
          <React.Fragment key={c.label}>
            {i > 0 && <ChevronRight className="w-4 h-4" />}
            {c.to ? (
              <Link to={c.to} className="hover:text-white transition-colors">{c.label}</Link>
            ) : c.href ? (
              <a href={c.href} className="hover:text-white transition-colors">{c.label}</a>
            ) : (
              <span className="text-white/90">{c.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>

      <div className={`grid grid-cols-1 ${aside ? "lg:grid-cols-5" : ""} gap-12 items-center`}>
        <div className={aside ? "lg:col-span-3" : "max-w-4xl"}>
          {badge && (
            <span className="inline-block px-4 py-1 bg-white/10 backdrop-blur-md text-white/90 rounded-full text-sm font-semibold mb-5 border border-white/20">
              {badge}
            </span>
          )}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-testid="page-title">
            {title}
          </h1>
          <p className="text-lg sm:text-xl text-white/80 mb-8 max-w-3xl">{intro}</p>

          <div className="flex flex-wrap items-center gap-3 mb-8">
            <StarRating rating={companyInfo.rating} />
            <span className="text-white font-semibold">{companyInfo.rating}</span>
            <span className="text-white/60">({companyInfo.reviewCount} Google reviews)</span>
          </div>

          {extra}

          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="bg-gradient-to-r from-sky-500 to-teal-500 hover:from-sky-600 hover:to-teal-600 text-white text-lg px-8 py-6 rounded-xl shadow-lg shadow-sky-500/30 hover:scale-105 transition-all">
              <a href="#calculator" data-testid="page-hero-calculator-btn">Bereken direct uw prijs</a>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-2 border-white/30 bg-white/10 backdrop-blur-md text-white hover:bg-white/20 text-lg px-8 py-6 rounded-xl transition-all">
              <a href={`tel:${companyInfo.phoneClean}`} className="flex items-center gap-2" data-testid="page-hero-phone-btn">
                <Phone className="w-5 h-5" />
                <span>{companyInfo.phone}</span>
              </a>
            </Button>
          </div>
        </div>
        {aside && <div className="lg:col-span-2">{aside}</div>}
      </div>
    </div>
  </section>
);

export default PageHero;
